module.exports = __webpack_public_path__ + "img/92480.e7f7f8c2.jpg";